import Vue from 'vue';
import Router from 'vue-router';
import VueJwtDecode from 'vue-jwt-decode';

// Containers
import Full from '@/containers/Full';
import 'vue-search-select/dist/VueSearchSelect.css'
// Views
import dashboard from '@/views/components/dashboard';
import handoverDashboard from '@/views/components/handoverDashboard';
import showHandOverReturnShipment from '@/views/components/showHandOverReturnShipment';
import Charts from '@/views/Charts';
import Widgets from '@/views/Widgets';
// Views - Components
import Buttons from '@/views/components/Buttons';
import SocialButtons from '@/views/components/SocialButtons';
import Cards from '@/views/components/Cards';
import Forms from '@/views/components/Forms';
import Modals from '@/views/components/Modals';
import Switches from '@/views/components/Switches';
import Tables from '@/views/components/Tables';
import Pagination from '@/views/components/pagination';

// Views - Icons
import FontAwesome from '@/views/icons/FontAwesome';
import SimpleLineIcons from '@/views/icons/SimpleLineIcons';
import CryptoJS from 'crypto-js';

// Views - Pages
import Page404 from '@/views/pages/Page404';
import Page500 from '@/views/pages/Page500';
import Login from '@/views/components/login';
import MarkingMisrouteODA from '@/views/components/MarkingMisrouteODA';
import UpdateCustomerDetails from '@/views/components/UpdateCustomerDetails';
import ShiftShipment from '@/views/components/ShiftShipment';
import CargoShiftShipmentDestinationHub from '@/views/components/CargoShiftShipmentDestinationHub';
import ChangeRTOandShipmentDetails from '@/views/components/ChangeRTOandShipmentDetails';
import agenthandover from '@/views/components/agenthandover';
import agentHandoverDashboard from '@/views/components/agentHandoverDashboard';
import agentShowHandOverReturnShipment from '@/views/components/agentShowHandOverReturnShipment';
import agentinscan from '@/views/components/agentinscan';
import agentreturntosvc from '@/views/components/agentreturntosvc';
import agentinscanreturn from '@/views/components/agentinscanreturn';
import LostModuleDashboard from '@/views/components/LOST/LostModuleDashboard';
import RMApprove from '@/views/components/LOST/RMApprove';
import BulkNotifyNoInfoShipments from '@/views/components/LOST/BulkNotifyNoInfoShipments';
import MarkLostShipment from '@/views/components/LOST/MarkLostShipment';
import Pickuploss from '@/views/components/LOST/pickuploss';
import RaiseDebit from '@/views/components/LOST/RaiseDebit';
import HubMarkLostDebit from '@/views/components/LOST/HubMarkLostDebit';
import HubMarkPickupLossDebit from '@/views/components/LOST/HubMarkPickupLossDebit';
import EditDebit from '@/views/components/LOST/EditDebit';
import LogisticMarkDebitTransitApproval from '@/views/components/LOST/LogisticMarkDebitTransitApproval';
import BulkTransitLostMark from '@/views/components/LOST/BulkTransitLostMark';
import LostShipmentDetails from '@/views/components/LOST/LostShipmentDetails';
import AllocateHandoverShipment from '@/views/components/AllocateHandoverShipment';
import ShipmentScanTallyNew from '@/views/components/ScanTally/ShipmentScanTallyNew';
import shipmentScanTallyAuditNew from '@/views/components/ScanTally/shipmentScanTallyAuditNew';
import ScantallyDownloadreport from '@/views/components/ScanTally/ScantallyDownloadreport';
import VerifyShipmentBrandBox from '@/views/components/VerifyShipmentBrandBox';
import ShipmentScanTallyReport from '@/views/components/ScanTally/ShipmentScanTallyReport';
import UploadScanPODSheet from '@/views/components/ScanPODSheet/UploadScanPODSheet';
import SetShipmentStatus from '@/views/components/SetShipmentStatus';
import RTODeliveryStatus from '@/views/components/RTODeliveryStatus';
import ScanPODReport from '@/views/components/ScanPODSheet/ScanPODReport';
import VerifyReversePickupFromCustomer from '@/views/components/VerifyReversePickupFromCustomer';
import deliveryuserlogout from '@/views/components/deliveryuserlogout'
import Allocation from '@/views/components/Allocation';
import RouteAllocation from '@/views/components/RouteAllocation';
import ForceCloseTrip from '@/views/components/ForceCloseTrip';
import ePaymentTransactionsForShipment from '@/views/components/E_PaymentTransactionDetails/ePaymentTransactionsForShipment';
import ChangeShipmentDetails from '@/views/components/ChangeShipmentDetails/ChangeShipmentDetails';
import SetSRTripConfiguration from '@/views/components/SetSRTripConfiguration';
import ReversePickAcknowledgment from '@/views/components/ReversePickAcknowledgment';
import ReversePassQC from '@/views/components/ReversePassQC';
import DeliverySummery from '@/views/components/DeliverySummery';
import RVPPrintLabel from '@/views/components/RVPPrintLabel';
import InScanRVPShipments from '@/views/components/InScanRVPShipments';
import ManageShipment from '@/views/components/ManageShipment/ManageShipment';
import ShipmentSummary from '@/views/components/ShipmentSummary';
import UpdateStatus from '@/views/components/UpdateStatus';
import UpdateBusinessConfiguration from '@/views/components/UpdateBusinessConfiguration';
import DeliveredWhhandoverToInscan from '@/views/components/DeliveredWhhandoverToInscan';
import UserOFDShipmentPayloadDetails from '@/views/components/UserOFDShipmentPayloadDetails';
import PrintShipmentForDelivery from '@/views/components/PrintShipmentForDelivery';
import ReverseRunsheetClosure from '@/views/components/ReverseRunsheetClosure/ReverseRunsheetClosure';
import DeliveryOTPs from '@/views/components/DeliveryOTPs';
import GetFlyerBarcodes from '@/views/components/GetFlyerBarcodes';
import CheckNdrNprVerification from '@/views/components/CheckNdrNprVerification';
import FinanceApprove from '@/views/components/LOST/FinanceApprove';
import RTODTOStickerTracking from '@/views/components/RTODTOStickerTracking';
import showPODpending from '@/views/components/showPODpending';
import AgentScanTally from '@/views/components/ScanTally/AgentScanTally';
import CheckShipmentStatus from '@/views/components/LOST/CheckShipmentStatus';
import RvpFlierTracking from '@/views/components/RvpFlierTracking';
import ScanTallyReport from '@/views/components/ScanTally/ScanTallyReport';
import RemoveShipmentFromNDRVerification from '@/views/components/RemoveShipmentFromNDRVerification';
import UpdateNDR from '@/views/components/UpdateNDR';
import ShipmentUpdate from '@/views/components/ShipmentUpdate';
import UpdatePODQueueFlags from '@/views/components/UpdatePODQueueFlags';
import Shipmentdeallocation from '@/views/components/Shipmentdeallocation';
import UpdateFlyerBarcode from '@/views/components/UpdateFlyerBarcode';
import lostUploadApproval from '@/views/components/LOST/lostUploadApproval'
import shipmentRecon from '@/views/components/shipmentRecon'
//import maintaincePage from '@/views/components/maintaincePage';
import RouteSummary from '@/views/components/RouteSummary'
import SRAvailability from '@/views/components/SRAvailability'
import MisrouteRequestMaker from '@/views/components/MisrouteRequestMaker'
import podsearch from '@/views/components/podsearch'
import LogicalNDR from '@/views/components/LogicalNDR'
import CMTApprove from '@/views/components/LOST/CMTApprove';
import MisrouteRequestAssignee from '@/views/components/MisrouteRequestAssignee';
import MisrouteRequestChecker from '@/views/components/MisrouteRequestChecker';
import MisrouteRequestCheckerSVC from '@/views/components/MisrouteRequestCheckerSVC';
import DECEnableAllocation from '@/views/components/decenableallocation';
import B2BCargoDashboard from '@/views/components/B2BCargoDashboard'
import ReversePickupShipmentDetails from '@/views/components/ReversePickupShipmentDetails';
import IvrCallDetails from '@/views/components/IvrCallDetails';
// import AllocationPortal from '@/views/components/CommonAllocation/AllocationPortal';
import newallocationpage from '@/views/components/newallocationpage';
import newshipmentscantally from '@/views/components/ScanTally/NewShipmentScantally';
import newAgentScanTally from '@/views/components/ScanTally/newAgentScanTally';
import newallocationpagev2 from '@/views/components/newallocationpagev2';
import Scantallybatchclosure from '@/views/components/ScanTally/Scantallybatchclosure';
import kavachLogin from '@/views/components/kavachLogin'
import keycloak from '../common/Keycloak';
import RMApproveDashboard from '@/views/components/LOST/RMApproveDashboard';
import lostRecoverySummary from '@/views/components/LOST/LostRecoverySummary'
import EmployeeCategories from '@/views/components/EmpCategories';
import srTrackingWeb from '@/views/components/srTrackingWeb'
import StoreApproval from '@/views/components/LOST/StoreApproval';
import STDdamaged from '../views/components/STDdamaged';
import RVPPrintLabelNewv2 from '@/views/components/RVPPrintLabelNewv2';
import RVPVerifyAwbAndFlyer from '@/views/components/RVPVerifyAwbAndFlyer';
import RVPHoldReturnv2 from '@/views/components/RVPHoldReturn';
import shipmentRecoveryApproval from '@/views/components/LOST/shipmentRecoveryApproval'
import ShipmentSearch from '@/views/components/ShipmnetSearch'
import BulkAutoNotifyNoInfo from '@/views/components/LOST/BulkAutoNotify';
import vehicleAdhocRequests from '../views/components/vehicleAdhocRequests';
import shipmentallocationrouting from '@/views/components/shipmentallocationrouting';
import ridermanagement from '@/views/components/ridermanagement';

Vue.use(Router);
const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {      //path: '/',
      //path: '*',
      path: '/',
      // name: 'maintaincePage',
      // component: maintaincePage,
      redirect: '/dashboard',
      name: 'Dashboard',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: dashboard,
          meta: {
            requiresAuth: true,
            adminAuth: true,
            breadcrumb: [
              {
                name: 'Dashboard',
                link: '/dashboard'
              },
              {
                name: 'Dashboard'
              }
            ]
          }
        },
        {
          path: 'pagination',
          name: 'Pagination',
          component: Pagination,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/Pagination'
              },
              {
                name: 'Pagination'
              }
            ]
          }
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },

        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        },
        {
          path: '/MarkingMisrouteODA',
          name: 'Marking Misroute ODA',
          component: MarkingMisrouteODA,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Marking Misroute ODA'
              }
            ]
          }
        },
        // {
        //   path: '/AllocationPortal',
        //   name: 'Allocation Portal',
        //   component: AllocationPortal,
        //   meta: {
        //     // requiresAuth: true,
        //     breadcrumb: [
        //       {
        //         name: 'Home',
        //         link: '/dashboard'
        //       },
        //       {
        //         name: 'Allocation Portal'
        //       }
        //     ]
        //   }
        // },
        {
          path: '/newallocationpage',
          name: 'Shipment Allocation',
          component: newallocationpage,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Shipment Allocation'
              }
            ]
          }
        },
        {
          path: '/newallocationpagev2',
          name: 'Shipment Allocation v2',
          component: newallocationpagev2,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Shipment Allocation v2'
              }
            ]
          }
        },
        {
          path: '/shipmentallocationrouting',
          name: 'Shipment Allocation ( Routing )',
          component: shipmentallocationrouting,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Shipment Allocation ( Routing )'
              }
            ]
          }
        },
        {
          path: '/ridermanagement',
          name: 'Rider Management ( Routing )',
          component: ridermanagement,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Rider Management ( Routing )'
              }
            ]
          }
        },
        {
          path: '/MisrouteRequestMaker',
          name: 'Request Misroute',
          component: MisrouteRequestMaker,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Misroute Request Form'
              }
            ]
          }
        },
        {
          path: '/MisrouteRequestAssignee',
          name: 'Assign Checker',
          component: MisrouteRequestAssignee,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Misroute Request Assignee'
              }
            ]
          }
        },
        {
          path: '/MisrouteRequestChecker',
          name: 'MDM Checker Action',
          component: MisrouteRequestChecker,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Misroute Request Checker'
              }
            ]
          }
        },
        {
          path: '/MisrouteRequestCheckerSVC',
          name: 'SVC Checker Action',
          component: MisrouteRequestCheckerSVC,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'SVC Checker Action'
              }
            ]
          }
        },
        {
          path: '/AllocateHandoverShipment',
          name: 'Allocate Handover Shipment',
          component: AllocateHandoverShipment,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Allocate Handover Shipment'
              }
            ]
          }
        },
        {
          path: '/UpdateCustomerDetails',
          name: 'Update Customer Details',
          component: UpdateCustomerDetails,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Update Customer Details'
              }
            ]
          }
        },
        {
          path: '/ShiftShipment',
          name: 'Shift Shipment',
          component: ShiftShipment,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Shift Shipment'
              }
            ]
          }
        },
        {
          path: '/CargoShiftShipmentDestinationHub',
          name: 'Cargo ShiftShipment DestinationHub',
          component: CargoShiftShipmentDestinationHub,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Cargo ShiftShipment DestinationHub'
              }
            ]
          }
        },
        {
          path: '/ChangeRTOandShipmentDetails',
          name: 'Change RTO and Shipment Details',
          component: ChangeRTOandShipmentDetails,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Change RTO and Shipment Details'
              }
            ]
          }
        },
        {
          path: '/LostModuleDashboard',
          name: 'Lost Module Dashboard',
          component: LostModuleDashboard,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Lost Module Dashboard'
              }
            ]
          }
        },
        {
          path: '/RMApprove',
          name: 'RM Approve',
          component: RMApprove,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'RM Approve'
              }
            ]
          }
        },
        {
          path: '/BulkNotifyNoInfoShipments',
          name: 'Notify Noinfo Shipments',
          component: BulkNotifyNoInfoShipments,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Notify Noinfo Shipments'
              }
            ]
          }
        },
        {
          path: '/BulkAutoNotify',
          name: 'Bulk NoInfo Upload',
          component: BulkAutoNotifyNoInfo,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Bulk NoInfo Upload'
              }
            ]
          }
        },
        {
          path: '/MarkLostShipment',
          name: 'Raise Debit and Mark Lost',
          component: MarkLostShipment,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Mark Lost Shipment'
              }
            ]
          }
        },
        {
          path: '/pickuploss',
          name: 'Forward Potential PickupLoss',
          component: Pickuploss,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Forward PickLoss'
              }
            ]
          }
        },
        {
          path: '/RaiseDebit',
          name: 'Investigation Lost',
          component: RaiseDebit,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Process Notified Lost Shipment'
              }
            ]
          }
        },
        {
          path: '/HubMarkLostDebit',
          name: 'Hub Mark LostDebit',
          component: HubMarkLostDebit,
          meta: {
            // requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'HubMarkLostDebit'
              }
            ]
          }
        },
        {
          path: '/HubMarkPickupLossDebit',
          name: 'Hub Mark PickupLoss Debit',
          component: HubMarkPickupLossDebit,
          meta: {
            // requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Forward PickLoss',
                link: '/pickuploss'
              },
              {
                name: 'Forward PickLoss Debit'
              }
            ]
          }
        },
        {
          path: '/EditDebit',
          name: 'Edit Debit',
          component: EditDebit,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'RaiseDebit',
                link: '/RaiseDebit'
              },
              {
                name: 'EditDebit'
              }
            ]
          }
        },
        {
          path: '/CMTApprove',
          name: 'CMT Approve',
          component: CMTApprove,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'CMT Approval Dashboard'
              }
            ]
          }
        },
        {
          path: '/handoverdashboard',
          name: 'Handover Return Dashboard',
          component: handoverDashboard,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Handover Return Dashboard'
              }
            ]
          }
        },
        {
          path: '/showhandoverreturnshipment',
          name: 'Show Handover Return Shipments',
          component: showHandOverReturnShipment,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Show Handover Return Shipments'
              }
            ]
          }
        },
        {
          path: '/agenthandoverdashboard',
          name: 'Agent Prealert Dashboard',
          component: agentHandoverDashboard,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Agent Prealert Dashboard'
              }
            ]
          }
        },
        {
          path: '/agentshowhandoverreturnshipment',
          name: 'Show Handover/Return Shipments',
          component: agentShowHandOverReturnShipment,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Show Return Shipments'
              }
            ]
          }
        },
        {
          path: '/agenthandover',
          name: 'Agent Handover/Return',
          component: agenthandover,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Agent Handover/Return'
              }
            ]
          }
        },
        {
          path: '/agentreturntosvc',
          name: 'Takeover/Return to SVC',
          component: agentreturntosvc,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Takeover/Return to SVC'
              }
            ]
          }
        },
        {
          path: '/agentinscan',
          name: 'Agent Inscan Process',
          component: agentinscan,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Agent Inscan Process'
              }
            ]
          }
        },
        {
          path: '/agentinscanreturn',
          name: 'Inscan Return Shipment',
          component: agentinscanreturn,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Inscan Return Shipment'
              }
            ]
          }
        },
        {
          path: '/LogisticMarkDebitTransitApproval',
          name: 'Transit Approve',
          component: LogisticMarkDebitTransitApproval,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Logistic Mark Debit-Transit Approval'
              }
            ]
          }
        },
        {
          path: '/BulkTransitLostMark',
          name: 'Bulk Transit Lost Mark',
          component: BulkTransitLostMark,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Bulk Transit Lost Mark'
              }
            ]
          }
        },
        {
          path: '/LostShipmentDetails',
          name: 'Shipments Search',
          component: LostShipmentDetails,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Lost Shipments Details'
              }
            ]
          }
        },
        {
          path: '/ShipmentScanTallyNew',
          name: 'Shipment ScanTally',
          component: ShipmentScanTallyNew,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Shipment Scan and Audit Tally'
              }
            ]
          }
        },
        {
          path: '/shipmentScanTallyAuditNew',
          name: 'Audit Shipment Tally',
          component: shipmentScanTallyAuditNew,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Audit Shipment Tally'
              }
            ]
          }
        },
        {
          path: '/ScantallyDownloadreport',
          name: 'Scan Tally Download Report',
          component: ScantallyDownloadreport,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Scan Tally Download Report'
              }
            ]
          }
        },
        {
          path: '/VerifyShipmentBrandBox',
          name: 'Verify Shipment Brand Box',
          component: VerifyShipmentBrandBox,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Verify Shipment Brand Box'
              }
            ]
          }
        },
        {
          path: '/ShipmentScanTallyReport',
          name: 'Shipment Scan Tally Report',
          component: ShipmentScanTallyReport,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Shipment Scan Tally Report'
              }
            ]
          }
        },
        {
          path: '/UploadScanPODSheet',
          name: 'Upload Scan POD Sheet',
          component: UploadScanPODSheet,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Upload Scan POD Sheet'
              }
            ]
          }
        },
        {
          path: '/SetShipmentStatus',
          name: 'Set Shipment Status',
          component: SetShipmentStatus,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Set Shipment Status'
              }
            ]
          }
        },{
          path: '/RTODeliveryStatus',
          name: 'RTO/DTO',
          component:RTODeliveryStatus,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Add RTO/DTO Delivery Status'
              }
            ]
          }
        },
        {
          path: '/ScanPODReport',
          name: 'Scan POD Report',
          component: ScanPODReport,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Scan POD Report'
              }
            ]
          }
        },{
          path: '/VerifyReversePickupFromCustomer',
          name: 'RVP PIC Done',
          component:VerifyReversePickupFromCustomer,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Verify Reverse Pickup From Customer'
              }
            ]
          }
        },
        {
          path: '/deliveryuserlogout',
          name: 'Delivery User Logout',
          component:deliveryuserlogout,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Delivery User Logout'
              }
            ]
          }
        },
        {
          path: '/CreateRunSheet',
          name: 'Create Run Sheet',
          component: Allocation,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/CreateRunSheet'
              },
              {
                name: 'Create Run Sheet '
              }
            ]
          }
        },
        {
          path: '/CreateRunSheetRoute',
          name: 'Create Run Sheet Route',
          component: RouteAllocation,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/CreateRunSheetRoute'
              },
              {
                name: 'Create Run Sheet Route'
              }
            ]
          }
        },
        {
          path: '/RouteSummary',
          name: 'Route Summary',
          component: RouteSummary,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/RouteSummary'
              },
              {
                name: 'Route Summary'
              }
            ]
          }
        },
        {
          path: '/SRAvailability',
          name: 'SR Availability',
          component: SRAvailability,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/SRAvailability'
              },
              {
                name: 'SR Availability'
              }
            ]
          }
        },
        {
          path: '/ePaymentTransactionsForShipment',
          name: 'E-Pay Transactions',
          component: ePaymentTransactionsForShipment,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'E-Payment Transactions Details'
              }
            ]
          }
        },
        {
          path: '/ForceCloseTrip',
          name: 'SR TripDetails',
          component: ForceCloseTrip,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'SR Trip Details'
              }
            ]
          }
        },
        {
          path: '/ChangeShipmentDetails',
          name: 'Change Shipment Details',
          component: ChangeShipmentDetails,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Change Shipment Details'
              }
            ]
          }
        },
        {
          path: '/SetSRTripConfiguration',
          name: 'SR TripConfiguration',
          component:SetSRTripConfiguration,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Set SR TripConfiguration'
              }
            ]
          }
        },
        {
          path: '/ReversePassQC',
          name: 'Reverse Pass QC',
          component:ReversePassQC,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Reverse Pass QC'
              }
            ]
          }
        },
        {
          path: '/DeliverySummery',
          name: 'Delivery Summery',
          component:DeliverySummery,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Delivery Summery'
              }
            ]
          }
        },
        {
          path: '/PrintLabel',
          name: 'Print Label',
          component:RVPPrintLabel,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Print Label'
              }
            ]
          }
        },
        {
          path: '/PrintLabelv2',
          name: 'Print Label v2',
          component:RVPPrintLabelNewv2,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Print Label'
              }
            ]
          }
        },
        {
          path: '/Varifyawbandflyer',
          name: 'Verify AWB and Flyer',
          component:RVPVerifyAwbAndFlyer,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Verify AWB and Flyer'
              }
            ]
          }
        },
        {
          path: '/RVPHoldReturn',
          name: 'RVP Hold Return',
          component:RVPHoldReturnv2,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'RVP Hold Return'
              }
            ]
          }
        },
        {
          path: '/InScanRVPShipments',
          name: 'InScan RVP Shipments',
          component:InScanRVPShipments,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'RVP Print Label/InScan'
              }
            ]
          }
        },
        {
          path: '/ManageShipment',
          name: 'Manage',
          component: ManageShipment,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Manage Shipment'
              }
            ]
          }
        },
        {
          path: '/ShipmentSummary',
          name: 'Shipment Summary',
          component: ShipmentSummary,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Shipment Summary'
              }
            ]
          }
        },
        {
          path: '/UpdateStatus',
          name: 'Update Status',
          component: UpdateStatus,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Update Shipment Status'
              }
            ]
          }
        },
        {
          path: '/UpdateBusinessConfiguration',
          name: 'Update Business Configuration',
          component: UpdateBusinessConfiguration,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Update Shipment Business Configuration'
              }
            ]
          }
        },
        {
          path: '/DeliveredWhhandoverToInscan',
          name: 'Delivered/Whhandover To Inscan',
          component: DeliveredWhhandoverToInscan,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Update Shipment Delivered/Whhandover To Inscan'
              }
            ]
          }
        },
        {
          path: '/UserOFDShipmentPayloadDetails',
          name: 'User OFD Shipment Payload Details',
          component: UserOFDShipmentPayloadDetails,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'User OFD Shipment Payload Details'
              }
            ]
          }
        },
        {
          path: '/PrintShipmentForDelivery',
          name: 'Print Shipments For Delivery',
          component: PrintShipmentForDelivery,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Print Shipments For Delivery'
              }
            ]
          }
        },
        {
          path: '/ReverseRunsheetClosure',
          name: 'Reverse Runsheet Closure',
          component:ReverseRunsheetClosure,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Reverse Runsheet Closure'
              }
            ]
          }
        },
        {
          path: '/RvpFlierTracking',
          name: 'Rvp Flier Tracking',
          component:RvpFlierTracking,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Rvp Flier Tracking'
              }
            ]
          }
        },
        {
          path: '/DeliveryOTPs',
          name: 'DeliveryOTPs',
          component:DeliveryOTPs,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Search Delivery OTPs'
              }
            ]
          }
        },
        {
          path: '/GetFlyerBarcodes',
          name: 'GetFlyerBarcodes',
          component:GetFlyerBarcodes,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Get Flyer Barcodes'
              }
            ]
          }
        },
        {
          path: '/CheckNdrNprVerification',
          name: 'CheckNdrNprVerification',
          component:CheckNdrNprVerification,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Check NDR NPR Verification'
              }
            ]
          }
        },
        {
         path: '/FinanceApprove',
         name: 'Finance Approve',
         component: FinanceApprove,
         meta: {
           //requiresAuth: true,
           breadcrumb: [
             {
               name: 'Home',
               link: '/dashboard'
             },
             {
               name: 'Logistics Mark Debit - Finance Close Debit'
             }
           ]
         }
       },
       {
         path: '/RTODTOStickerTracking',
         name: 'RTO DTO Sticker Tracking',
         component: RTODTOStickerTracking,
         meta: {
           requiresAuth: true,
           breadcrumb: [
             {
               name: 'Home',
               link: '/dashboard'
             },
             {
               name: 'RTO DTO Sticker Tracking'
             }
           ]
         }
       },
       {
         path : '/showPODpending',
         name : 'Show POD Pending Count',
         component : showPODpending,
         meta : {
           requiresAuth : true,
           breadcrumb : [
             {
               name: 'Home',
               link: '/dashboard'
             },
             {
               name: 'Show POD Pending Count'
             }
           ]
         }
       },
       {
        path : '/ReversePickupShipmentDetails',
        name : 'Reverse Pickup Shipment Details',
        component : ReversePickupShipmentDetails,
        meta : {
          requiresAuth : true,
          breadcrumb : [
            {
              name : 'Home',
              link : '/dashboard'
            },
            {
              name : 'Reverse Pickup Shipment Details'
            }
          ]
        }
       },
       {
          path: '/AgentScanTally',
          name: 'Agent Scan Tally',
          component: AgentScanTally,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Agent Scan Tally'
              }
            ]
          }
        },
        {
        path : '/CheckShipmentStatus',
        name : 'Change Shipment Status',
        component : CheckShipmentStatus,
        meta : {
          requiresAuth : true,
          breadcrumb : [
            {
              name: 'Home',
              link: '/dashboard'
            },
            {
              name: 'Change Shipment Status'
            }
          ]
        }
      },
      {
        path : '/ScanTallyReport',
        name : 'ScanTally Report',
        component : ScanTallyReport,
        meta : {
          requiresAuth : true,
          breadcrumb : [
            {
              name: 'Home',
              link: '/dashboard'
            },
            {
              name: 'ScanTally Report'
            }
          ]
        }
      },
      {
          path: '/RemoveShipmentFromNDRVerification',
          name: 'RemoveShipment From NDRVerification',
          component: RemoveShipmentFromNDRVerification,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Remove Shipment From NDR Verification'
              }
            ]
          }
        },
        {
          path: '/UpdateNDR',
          name: 'Update NDR',
          component: UpdateNDR,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Update NDR'
              }
            ]
          }
        },
        {
        path : '/ShipmentUpdate',
        name : 'Update Shipment Status',
        component : ShipmentUpdate,
        meta : {
          requiresAuth : true,
          breadcrumb : [
            {
              name: 'Home',
              link: '/dashboard'
            },
            {
              name: 'Update Shipment Status'
            }
          ]
        }
      },
      {
        path : '/UpdatePODQueueFlags',
        name : 'Update PODQueueFlags',
        component : UpdatePODQueueFlags,
        meta : {
          requiresAuth : true,
          breadcrumb : [
            {
              name: 'Home',
              link: '/dashboard'
            },
            {
              name: 'Update PODQueueFlags'
            }
          ]
        }
      },
      {
        path : '/UnlockAllocation',
        name : 'Unlock Allocation',
        component : DECEnableAllocation,
        meta : {
          requiresAuth : true,
          breadcrumb : [
            {
              name: 'Home',
              link: '/dashboard'
            },
            {
              name: 'Unlock Allocation'
            }
          ]
        }
      },
      {
          path: '/Shipmentdeallocation',
          name: 'ShipmentDeallocation',
          component: Shipmentdeallocation,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Shipment Deallocation'
              }
            ]
          }
        },
        {
          path: '/EmployeeCategories',
          name: 'Employee Categories',
          component: EmployeeCategories,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Employee Categories'
              }
            ]
          }
        },
        {
          path: '/UpdateFlyerBarcode',
          name: 'Update Flyer Barcode',
          component: UpdateFlyerBarcode,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'UpdateFlyerBarcode'
              }
            ]
          }
        },
        {
          path: '/lostUploadApproval',
          name: 'HR/Finance Recovery upload',
          component: lostUploadApproval,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/lostUploadApproval'
              },
              {
                name: 'HR / Finance Recovery upload'
              }
            ]
          }
        },
        {
          path: '/podsearch',
          name: 'POD Search',
          component: podsearch,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/podsearch'
              },
              {
                name: 'POD Search'
              }
            ]
          }
        },
        {
          path: '/LogicalNDR',
          name: 'Logical NDR/NPR',
          component: LogicalNDR,
          meta: {
             requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/LogicalNDR'
              },
              {
                name: 'Logical NDR/NPR'
              }
            ]
          }
        },
        {
          path: '/shipmentRecon',
          name: 'Shipment Reconciliation',
          component: shipmentRecon,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/shipmentRecon'
              },
              {
                name: 'Shipment Reconciliation'
              }
            ]
          }
        },
        {
          path: '/b2bcargo',
          name: 'B2B Cargo',
          component: B2BCargoDashboard,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/b2bcargo'
              },
              {
                name: 'B2B Cargo'
              }
            ]
          }
        },
        {
          path: '/newshipmentscantally',
          name: 'Scan Tally (v2)',
          component: newshipmentscantally,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/newshipmentscantally'
              },
              {
                name: 'Shipment Scantally'
              }
            ]
          }
        },
        {
          path: '/ivrcalldetails',
          name: 'IVR Call Details',
          component: IvrCallDetails,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'IVR Call Details'
              }
            ]
          }
        },
        {
          path: '/newAgentScanTally',
          name: 'Agent Scan Tally (v2)',
          component: newAgentScanTally,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/newAgentScanTally'
              },
              {
                name: 'Agent Scantally'
              }
            ]
          }
        },
        {
          path: '/Scantallybatchclosure',
          name: 'Scantally Batch Closure',
          component: Scantallybatchclosure,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/Scantallybatchclosure'
              },
              {
                name: 'Scantally Batch Closure'
              }
            ]
          }
        },
        {
          path: '/RMApproveDashboard',
          name: 'RM Approve Dashboard',
          component: RMApproveDashboard,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'RM Approve Dashboard'
              }
            ]
          }
        },
        {
          path: '/lostRecoverySummary',
          name: 'Lost Recovery Summary',
          component: lostRecoverySummary,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'lostRecoverySummary'
              }
            ]
          }
        },
        {
          path: '/StoreApproval',
          name: 'Store Approval',
          component: StoreApproval,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Store Approval'
              }
            ]
          }
        },
        {
          path: '/srTracking',
          name: 'SR Tracking',
          component: srTrackingWeb,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/srTracking'
              },
              {
                name: 'SR Tracking'
              }
            ]
          }
        },
        {
          path: '/stddamaged',
          name: 'Damaged Marking STD',
          component: STDdamaged,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Damaged Marking STD'
              }
            ]
          }
        },
        {
          path: '/ShipmentSearch',
          name: 'ShipmentSearch',
          component: ShipmentSearch,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'ShipmentSearch'
              }
            ]
          }
        },
        {
          path: '/vehicleAdhocRequests',
          name: 'Vehicle Adhoc Requests',
          component: vehicleAdhocRequests,
          meta: {
            requiresAuth: false,
            breadcrumb: [
              {
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Vehicle Adhoc Requests'
              }
            ]
          }
        },
        {
          path: '/shipmentRecoveryApproval',
          name: 'Shipment Recovery upload',
          component: shipmentRecoveryApproval,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Home',
                link: '/shipmentRecoveryApproval'
              },
              {
                name: 'Shipment Recovery upload'
              }
            ]
          }
        }
      ]
    },
    // {
    //   path: '/*',
    //   name: 'maintaincePage',
    //   component: maintaincePage,
    // },
    {
      path: '/login/:id?',
      name: 'login',
      component: Login
    },
    {
      path: '/kavachlogin',
      name: 'kavachlogin',
      component: kavachLogin
    },
    {
      path: '/ReversePickAcknowledgment/:shippingId',
      name: 'ReversePickAcknowledgment',
      component: ReversePickAcknowledgment
    },
    {
      path: '/ShipmentSummary/:shipmentNo',
      name: 'ShipmentSummary',
      component: ShipmentSummary,
      meta: {
        requiresAuth: false
        }
    },
    {
      path: '/pages',
      redirect: '/pages/p404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  let kavachEnabled = (to && to.name == "ReversePickAcknowledgment") ? false : true;
  if (keycloak.enableKavach && kavachEnabled) {
    /**
     * New code created for kavach login
     */
    let isLoggedIn = window.localStorage.getItem('isLoggedIn');
    isLoggedIn = ((isLoggedIn == null || isLoggedIn == undefined) ? false : true);
    if (!isLoggedIn) {
      let printRoute = window.localStorage.getItem('printRoute');
      if((typeof printRoute == undefined || printRoute == "" || printRoute == null) && to.path == "/PrintLabelv2"){
        window.localStorage.setItem('printRoute',to.path);
      }
      let auth = await keycloak.init({ onLoad: 'login-required' });
      if (auth) {
        window.localStorage.setItem('isLoggedIn', true);
        window.localStorage.setItem('lmUserToken', keycloak.token);
        window.localStorage.setItem('refreshToken', keycloak.refreshToken);
        window.localStorage.setItem('lmUserTokenId', keycloak.idToken);
        let decoded = VueJwtDecode.decode(keycloak.token);
        next({ path: '/kavachlogin' });
        return;
      } else {
        window.location.reload();
      }
    } else {
      let userUniqueKey = window.localStorage.getItem('userUniqueKey');
      let isLoginAuthCheck = window.localStorage.getItem('isLoginAuthCheck');
      if (isLoginAuthCheck != null && userUniqueKey == null) {
        keycloak.logoutWithTokenId();
      } else {
        if (to.matched.some(record => record.meta.requiresAuth)) {
          let userDataKey = window.localStorage.getItem('userUniqueKey');
          let permissionEncrypt = window.localStorage.getItem('lmaccesspermissiondata');
          let bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), userDataKey);
          let plaintext = bytes.toString(CryptoJS.enc.Utf8);
          let permissiondata = JSON.parse(plaintext);

          // function isBigEnough(findURL) {
          //   if (findURL.children.length > 0) {
          //     return isBigChildEnough(findURL.children)
          //   } else {
          //     return findURL.name == to.name;
          //   }
          // }

          // Old Code Kavach
          // function isBigEnough(findURL) {
          //   if (findURL.children.length > 0) {
          //     let flag = 0;
          //     for (let i = 0; i < findURL.children.length; i++) {
          //       if (findURL.children[i].children.length > 0) {
          //         flag = findURL.children[i].children.some(isBigChildEnough);
          //         if (flag) break;
          //       }
          //     }
          //     if (flag) return flag;
          //     return findURL.children.some(isBigChildEnough);
          //   }
          //   return findURL.url == to.path;
          // }

          // function isBigChildEnough(findURL) {
          //   return findURL.url == to.path;
          // }

          // function isBigChildEnough(findURLNested) {
          //   return findURLNested.some(isBigEnough)
          // }


          // let setroles = permissiondata.some(isBigEnough);
          // if (setroles) {
          //   next();
          // } else {
          //   next({
          //     path: permissiondata[0].url
          //   });
          // }


          // Updated code kavach start
          function isBigEnough(findURL) {
            if (findURL.children.length > 0) {
              return isBigChildEnough(findURL.children)
            } else {
              return findURL.name == to.name;
            }
          }
          function isBigChildEnough(findURLNested) {
            return findURLNested.some(isBigEnough)
          }
          let setroles = permissiondata.some(isBigEnough);
          if (setroles) {
            next();
          } else {
            next({
              path: permissiondata[0].url
            });
          }
          // updated code kavach end
        } else {
          next();
        }
      }
    }
  } else {
    /**
     * Old code
     */
    let isLoggedIn = window.localStorage.getItem('isLoggedIn');
    if (isLoggedIn == null || isLoggedIn == undefined) {
      isLoggedIn = false;
    } else {
      isLoggedIn = true;
    }

    if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
      next({
        path: '/login'
      });
    } else {
      if (to.matched.some(record => record.meta.requiresAuth)) {
        const permissionEncrypt = window.localStorage.getItem(
          'lmaccesspermissiondata'
        );
        let userDataKey = window.localStorage.getItem('userUniqueKey');
        const bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), userDataKey);
        const plaintext = bytes.toString(CryptoJS.enc.Utf8);
        const permissiondata = JSON.parse(plaintext);
        function isBigEnough(findURL) {
          if (findURL.children.length > 0) {
            return isBigChildEnough(findURL.children)
          } else {
            return findURL.name == to.name;
          }
        }
        function isBigChildEnough(findURLNested) {
          return findURLNested.some(isBigEnough)
        }
        const setroles = permissiondata.some(isBigEnough);
        if (setroles) {
    next();
        } else {
          next({
            path: permissiondata[0].url
          });
        }
      } else {
        next();
      }
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js